<template>
    <!--begin::Wrapper-->
    <div id="dnn_ctr464_ModuleContent" class="DNNModuleContent ModDNNHTMLC">
        <div id="dnn_ctr464_HtmlModule_lblContent" class="Normal">
            <div class="pageBg">
                <div class="pageBgInners mt-20" data-aos="fade-up">
                    <div class="container mt-20">
                        <div class="row mt-20 justify-content-center">
                            <div class="col-md-12  mt-20">
                                <div class="row mt-20">
                                    <div class="col-md-12 mt-20"></div>

                                    <div class="col-md-12">
                                        <div v-if="loading"
                                             class="row justify-content-center bg-white rounded shadow-sm p-10 p-lg-15  mx-auto">
                                            <div class="col-12" v-for="k in [1,2,3]">
                                                <div class="row">
                                                    <div class="col-12 text-center mb-10"></div>
                                                    <div class="col-md-4 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-4 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            class="w-100"
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-4 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-12 text-center mb-10"></div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            class="w-100"
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-12 text-center mb-10"></div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-6 mb-10 text-center">
                                                        <free-style-shimmer :is-loading='true' height='10px'
                                                                            width='200px'
                                                                            color='#bdbdbd'/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card" v-if="ProgramData">
                                            <div class="card-header">
                                                <div class="card-title fs-2 fw-bolder">
                                                    <slot v-if="i18n.locale.value == 'ar'">
                                                        {{ProgramData ? ProgramData.name.ar : ''}}
                                                    </slot>
                                                    <slot v-if="i18n.locale.value == 'en'">
                                                        {{ProgramData ? ProgramData.name.en : ''}}
                                                    </slot>

                                                </div>
                                                <button @click="goToPrograms()" class="btn btn-secondary float-end">
                                                    <i class="uil uil-corner-up-right fs-1"></i>
                                                </button>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <div class="alert bg-success">
                                                            <p class="m-0 text-white">
                                                                {{$t('success_apply')}}
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <div class="row">
                                                                <div class="col-md-4" v-for="(step,key) in steps">

                                                                    <button class="btn btn-dark mb-2 text-start btn-block w-100"
                                                                            type='button'
                                                                            data-bs-toggle='modal'
                                                                            data-bs-target='#show_show_modal'
                                                                            @click="showModalPrograms(step._id)">
                                                                        <i v-if="isSubmitted(step._id)"
                                                                           class="uil uil-check-circle text-success fa-3x"
                                                                           style="font-size: 18px"></i>
                                                                        <i v-if="!isSubmitted(step._id)"
                                                                           class="uil uil-cross text-danger fa-3x"></i>
                                                                        &nbsp;
                                                                        <slot v-if="i18n.locale.value == 'ar'">
                                                                            {{step.formJson.title_ar}}
                                                                        </slot>
                                                                        <slot v-if="i18n.locale.value == 'en'">
                                                                            {{step.formJson.title}}
                                                                        </slot>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <button class="btn btn-danger"
                                                                        @click="goToEditProgram(ProgramData._id)">
                                                                    {{$t('edit_program')}}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <vs-tabs>
                                                                    <vs-tab color="danger" defaultColor="dark"
                                                                            :label="$t('description')">
                                                                        <div class="con-tab-ejemplo fs-5">
                                                                            <slot v-if="i18n.locale.value == 'ar'">
                                                                                {{ProgramData ?
                                                                                ProgramData.description.ar : ''}}
                                                                            </slot>
                                                                            <slot v-if="i18n.locale.value == 'en'">
                                                                                {{ProgramData ?
                                                                                ProgramData.description.en : ''}}
                                                                            </slot>
                                                                        </div>
                                                                    </vs-tab>

                                                                    <vs-tab color="danger" defaultColor="dark"
                                                                            :label="$t('terms')">
                                                                        <div class="con-tab-ejemplo fs-5">
                                                                            <slot v-if="i18n.locale.value == 'ar'">
                                                                                <div v-html="ProgramData.termsAndConditions.ar"></div>
                                                                            </slot>
                                                                            <slot v-if="i18n.locale.value == 'en'">
                                                                                <div v-html="ProgramData.termsAndConditions.en"></div>
                                                                            </slot>
                                                                        </div>
                                                                    </vs-tab>
                                                                </vs-tabs>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="text-center">
                                                            <client-only>
                                                                <Vue3Lottie
                                                                        animationLink="https://assets5.lottiefiles.com/packages/lf20_s3u31uyq.json"
                                                                />
                                                            </client-only>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cloudsTop"></div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='show_show_modal' tabindex='-1' role='dialog' ref="ModalShow"
         aria-labelledby='show_users_modalLabel' aria-hidden='true'>
        <div class='modal-dialog modal-xl' role='document'>
            <div class='modal-content'>
                <div class='modal-header'>
                    <h2 class='modal-titles text-danger' id='show_show_modalLabel'>
                        <slot v-if="i18n.locale.value == 'ar'">
                            {{selectedSubmission ? selectedSubmission.formJsonId.formJson.title_ar : ''}}
                        </slot>
                        <slot v-if="i18n.locale.value == 'en'">
                            {{selectedSubmission ? selectedSubmission.formJsonId.formJson.title : ''}}
                        </slot>
                    </h2>

                    <!--begin::Close-->
                    <div class='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                            <span class='svg-icon svg-icon-1'>
                              <inline-svg src='media/icons/duotune/arrows/arr061.svg'/>
                            </span>
                    </div>
                    <!--end::Close-->
                </div>
                <div class='modal-body'>
                    <div v-if='!selectedSubmission'
                         class='overlay overlay-block   d-flex justify-content-center align-items-center'
                         style='min-height: 350px;position: absolute;width: 100%;height: 100%;z-index: 8;background: #fff;right: 0;'>
                                <span class='indicator-progress' style='display: block'>
                                        {{ $t('loading') }}
                                        <span class='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                    </div>

                    <div v-if="selectedSubmission">
                        <div class="table-responsive position-relatives">
                            <!--<div class="position-absolute"-->
                            <!--style="background: black;width: 100%;height: 100%;z-index: 99;opacity: 0.1;top:0;right:0;left: 0;cursor: not-allowed;"></div>-->
                            <FormBuilder :key="Math.random().toString(16)"
                                         v-bind="{items:selectedSubmission.formJsonWithData}"
                            />
                        </div>
                    </div>

                </div>
                <div class='modal-footer' v-if="selectedSubmission">
                    <button type='button' class='btn btn-sm btn-secondary' data-bs-dismiss='modal'
                            @click='selectedSubmission=null'>
                        {{ $t('close') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!--end::Wrapper-->
</template>

<script lang="ts">
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Tab } from 'bootstrap';
  import { useI18n } from 'vue-i18n';
  import AOS from 'aos';
  import * as _ from 'lodash';

  import FormInput from '@/views/programs/components/FormInput.vue';
  import FormFileInput from '@/views/programs/components/FormFileInput.vue';
  import FormDateInput from '@/views/programs/components/FormDateInput.vue';
  import FormCheckboxInput from '@/views/programs/components/FormCheckboxInput.vue';
  import RecursiveSelect from '@/views/programs/components/RecursiveSelect.vue';
  import FormBuilder from '@/views/programs/components/FormBuilder.vue';

  export default defineComponent({
    name: 'apply',
    components: {
      Tab,

      Field,
      Form,
      ErrorMessage,

      FormBuilder,
      RecursiveSelect,
      FormCheckboxInput,
      FormDateInput,
      FormFileInput,
      FormInput,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const i18n = useI18n();
      const { t } = useI18n();

      const user = computed(() => {
        return store.getters['moduleAuth/getAuthUser'];
      });

      let emptyArray: any = [];
      let currentSelected: any = null;
      const state = reactive({
        loading: false,
        started: false,
        currentStep: null,
        selectedSubmission: currentSelected,

        ProgramData: null,
        steps: emptyArray,
      });

      onMounted(() => {
        AOS.init();
        getProgram();
      });

      const getProgram = () => {
        state.loading = true;
        let id: any = route?.params?.id;
        store.dispatch('modulePrograms/findProgramDetails', { id: id })
          .then(({ data }) => {
            state.loading = false;
            let response = data.data;
            state.ProgramData = data.data;
            state.steps = response.dynamicFormsJsonWithOrder;
          })
          .catch((response) => {
            state.loading = false;
            helpers.handleResponse(response, t, router, store, {});
          });
      };

      const goToPrograms = () => {
        router.push({ name: 'all_programs_page' });
      };

      const goToEditProgram = (id) => {
        router.push({ name: 'apply_program_page', params: { id: id } });
      };

      const isSubmitted = (id) => {
        let ProgramData: any = state.ProgramData;
        let flag = false;
        if(!ProgramData.formJsonSubmission){
          return false;
        }
        _.forEach(ProgramData.formJsonSubmission.formSubmissions, (form) => {
          if (form.formJsonId._id == id) {
            flag = true;
          }
        });
        return flag;
      };

      const showModalPrograms = (id) => {
        let ProgramData: any = state.ProgramData;
        state.selectedSubmission = null;
        if(!ProgramData.formJsonSubmission){
          return false;
        }
        _.forEach(ProgramData.formJsonSubmission.formSubmissions, (form: any) => {
          if (form.formJsonId._id == id) {
            let formJson: any = form.formJsonId.formJson;
            let formJsonWithData: any = generateJsonFormWithData(formJson.items, form.formData[formJson.model_key]);
            form.formJsonWithData = formJsonWithData;
            setTimeout(() => {
              state.selectedSubmission = form;
            }, 500);
          }
        });
      };


      // generate form json with data
      const generateJsonFormWithData = (items, formData) => {
        return generateJsonFormItems(items, formData);
      };

      const generateSection = (items, section, sectionData, index) => {
        let value = JSON.parse(JSON.stringify(section));
        value.section_repeat_index = index;
        value.key = Math.random().toString(16);
        sectionData = refineFormData(sectionData);
        value.items = generateJsonFormItems(value.items, sectionData);
        return value;
      };

      const generateJsonFormItems = (items, formData) => {
        // console.log(items);
        formData = refineFormData(formData);
        for (let i = 0; i < items.length; i++) {
          if (items[i].type == 'Section') {
            if (formData[items[i].model_key] != null) {
              if (!Array.isArray(formData[items[i].model_key])) { // is map
                formData[items[i].model_key] = refineFormData(formData[items[i].model_key]);
                generateJsonFormItems(items[i].items, formData[items[i].model_key]);
              } else if (Array.isArray(formData[items[i].model_key])) { // is list
                for (let j = 0; j < formData[items[i].model_key].length; j++) {
                  let generatedSection = generateSection(items,
                    items[i],
                    formData[items[i].model_key][j],
                    j + 1,
                  );
                  if (j == 0) {
                    items[i] = generatedSection;
                  } else {
                    items.splice(j + i, 0, generatedSection);
                  }
                }
                i = parseInt(i + formData[items[i].model_key].length) - 1;
              }
            }
          } else if (items[i].type == 'Check') {

            items[i].key = Math.random().toString(16);
            items[i].values = formData[items[i].model_key] == null
              ? []
              : (typeof formData[items[i].model_key] === 'object') //     is array
                ? formData[items[i].model_key]
                : (typeof formData[items[i].model_key] === 'string') // is string
                  ? [formData[items[i].model_key]]
                  : (typeof formData[items[i].model_key] === 'number') // is number
                    ? [formData[items[i].model_key]]
                    : [];

          } else if (items[i].type == 'Radio' || items[i].type == 'DropDownList') {
            items[i].value = formData[items[i].model_key];
            items[i].key = Math.random().toString(16);
            let selectionValue = getSelectionValueByID(
              items[i].selection_values, (formData[items[i].model_key]),
            );
            if (selectionValue != null) {
              if (selectionValue.section != null) {
                if (!checkIfSectionAdded(items, selectionValue.section.model_key)) {
                  items.splice(i + 1, 0, selectionValue.section);
                }
              }
            }
          } else {
            items[i].value = formData[items[i].model_key];
            items[i].key = Math.random().toString(16);
          }
        }
        return items;
      };

      const refineFormData = (formData) => {
        const formKeys = Object.keys(formData);
        for (let i = 0; i < formKeys.length; i++) {
          if (Array.isArray(formData[formKeys[i]])) {
            refineFormDataList(formData[formKeys[i]]);
          } else if (typeof formData[formKeys[i]] === 'object' && formData[formKeys[i]] !== null) {
            formData[formKeys[i]] = refineFormData(formData[formKeys[i]]);
          }
        }
        return formData;
      };

      const refineFormDataList = (formDataList) => {
        for (let i = formDataList.length - 1; i >= 0; i--) {
          if (formDataList[i] === null) {
            formDataList.splice(i, 1);
          }
        }
      };

      const insertAfterIndex = (arr, index, newItem) => [
        ...arr.slice(0, index),
        newItem,
        ...arr.slice(index),
      ];

      const checkIfSectionAdded = (items, modelKey) => {
        for (let i = 0; i < items.length; i++) {
          if (items[i].model_key == modelKey) {
            return true;
          }
        }
        return false;
      };

      const getSelectionValueByID = (selectionValues, id) => {
        let selectionValue: any = null;
        for (let i = 0; i < selectionValues.length; i++) {
          if (selectionValues[i].id == id) {
            selectionValue = selectionValues[i];
            break;
          }
        }
        return selectionValue;
      };
      // end generate form json with data


      return {
        ...toRefs(state),
        isSubmitted,
        showModalPrograms,
        goToPrograms,
        goToEditProgram,
        i18n,
        user,
      };
    },
  });
</script>
<style>
    .vs-tabs--li {
        font-size: 15px;
        font-weight: bold;
    }
</style>
